export default {
  user: {
    profile: '프로필',
    identification: '신분 인증',
    bankCard: '은행 카드',
    deposit: '입금',
    withdraw: '출금',
  },
};
